import PropTypes from "prop-types";

import { Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate, formatMoney } from "@/features/shared";

const Field = ({ label, value, strong }) => (
  <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
    <Typography variant="body2" sx={{ color: "text.secondary" }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: strong ? "bold" : undefined }}>
      {value}
    </Typography>
  </Grid>
);

Field.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  strong: PropTypes.bool,
};

// Shared by the standard and lab purchase order detail pages. Both show the
// same header and price fields; the lab flow additionally carries the internal
// purchase order (retail customer + retail outlet), which is rendered only when
// present.
export const GeneralInformationSection = ({
  purchaseOrder,
  sellerLabel = "Penjual",
}) => {
  const { internalPurchaseOrder } = purchaseOrder;

  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>

        <Field label="Dibuat oleh" value={purchaseOrder.creator?.name || "-"} />
        <Field
          label="Tanggal Transaksi"
          value={formatDate(purchaseOrder.transactionDate)}
        />
        <Field label={sellerLabel} value={purchaseOrder.seller?.name || "-"} />
        <Field label="Outlet" value={purchaseOrder.buyer?.name || "-"} />
        <Field label="Gudang" value={purchaseOrder.warehouse?.name || "-"} />

        {internalPurchaseOrder && (
          <>
            <Field
              label="Pelanggan Retail"
              value={internalPurchaseOrder.customer?.name || "-"}
            />
            <Field
              label="Pembeli Internal (Outlet Retail)"
              value={internalPurchaseOrder.buyer?.name || "-"}
            />
          </>
        )}

        <Field
          label="Syarat Pembayaran"
          value={purchaseOrder.paymentTerm?.name || "-"}
        />
        <Field
          label="Subtotal"
          value={formatMoney(purchaseOrder.subtotal)}
        />
        <Field
          label="Total Diskon"
          value={formatMoney(purchaseOrder.totalDiscount)}
        />
        {purchaseOrder.taxable && (
          <Field
            label={`Pajak (${purchaseOrder.taxPercentage}%)`}
            value={formatMoney(purchaseOrder.taxAmount)}
          />
        )}
        <Field
          label="Grand Total"
          value={formatMoney(purchaseOrder.grandTotal)}
          strong
        />
        <Field
          label="Kena Pajak"
          value={purchaseOrder.taxable ? "Ya" : "Tidak"}
        />
        {purchaseOrder.taxable && (
          <Field
            label="Total Termasuk Pajak"
            value={purchaseOrder.totalIncludesTax ? "Ya" : "Tidak"}
          />
        )}
        <Field label="Catatan" value={purchaseOrder.note ?? "-"} />
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  purchaseOrder: PropTypes.object.isRequired,
  // "Penjual" for standard purchase orders, "Pemasok" for lab.
  sellerLabel: PropTypes.string,
};
